import { defineStore } from 'pinia';
import { LOGO, LOGO_PD, MT_LANDING_URL } from '~/core/i18n/constants';
import { LANDING_URL } from '~/core/constants';
import { COUNTRY_CODE } from '~/core/i18n/constants/countryCode';
import { getOnlyNumber } from '~/core/utils/getOnlyNumber';
import useProfileStore from '~/stores/useProfileStore';
import useCountriesStore from '~/stores/useCountriesStore';
export default defineStore('locale', function () {
  var profileStore = useProfileStore();
  var countriesStore = useCountriesStore();
  var isCis = computed(function () {
    return process.env.domain === 'CIS';
  });
  var isRu = computed(function () {
    return !isCis.value;
  });
  var pdSiteName = computed(function () {
    return isCis.value ? 'YDoc' : 'ПроДокторов';
  });
  var isUserLogged = computed(function () {
    return Boolean(profileStore.phone);
  });
  var pdUrl = computed(function () {
    return isUserLogged.value ? profileStore.pdUrl : countriesStore.pdUrl;
  });
  var currentDomainCountry = ref();
  var currentCountry = computed(function () {
    var _ref, _profileStore$country, _countriesStore$selec;
    return (_ref = isUserLogged.value ? (_profileStore$country = profileStore.country) === null || _profileStore$country === void 0 ? void 0 : _profileStore$country.iso : (_countriesStore$selec = countriesStore.selectedCountry) === null || _countriesStore$selec === void 0 ? void 0 : _countriesStore$selec.iso) !== null && _ref !== void 0 ? _ref : COUNTRY_CODE.RU;
  });
  var landingUrl = computed(function () {
    return MT_LANDING_URL[currentCountry.value] || LANDING_URL;
  });
  var logo = computed(function () {
    return LOGO[currentCountry.value] || LOGO[COUNTRY_CODE.RU];
  });
  var pdLogo = computed(function () {
    return LOGO_PD[currentCountry.value] || LOGO_PD[COUNTRY_CODE.RU];
  });
  var outgoingCallPhone = computed(function () {
    var _countriesStore$selec2;
    return (_countriesStore$selec2 = countriesStore.selectedCountry) === null || _countriesStore$selec2 === void 0 ? void 0 : _countriesStore$selec2.outgoingCallPhone;
  });
  var outgoingCallPhoneLink = computed(function () {
    return outgoingCallPhone.value ? "tel:".concat(getOnlyNumber(outgoingCallPhone.value)) : '';
  });
  var incomingCallPhone = computed(function () {
    var _countriesStore$selec3;
    return (_countriesStore$selec3 = countriesStore.selectedCountry) === null || _countriesStore$selec3 === void 0 ? void 0 : _countriesStore$selec3.callCodePhone;
  });
  var whatsappLink = computed(function () {
    var _countriesStore$selec4;
    return (_countriesStore$selec4 = countriesStore.selectedCountry) === null || _countriesStore$selec4 === void 0 ? void 0 : _countriesStore$selec4.whatsappLink;
  });
  var personalDataAgreementLink = computed(function () {
    var _countriesStore$selec5;
    return (_countriesStore$selec5 = countriesStore.selectedCountry) === null || _countriesStore$selec5 === void 0 ? void 0 : _countriesStore$selec5.personalDataAgreementLink;
  });
  var personalDataReceivingLink = computed(function () {
    var _countriesStore$selec6;
    return (_countriesStore$selec6 = countriesStore.selectedCountry) === null || _countriesStore$selec6 === void 0 ? void 0 : _countriesStore$selec6.personalDataReceivingLink;
  });
  var thirdPartyPersonalDataAgreementLink = computed(function () {
    var _countriesStore$selec7;
    return (_countriesStore$selec7 = countriesStore.selectedCountry) === null || _countriesStore$selec7 === void 0 ? void 0 : _countriesStore$selec7.thirdPartyPersonalDataAgreementLink;
  });
  var telegramBotLink = computed(function () {
    var _countriesStore$selec8;
    return (_countriesStore$selec8 = countriesStore.selectedCountry) === null || _countriesStore$selec8 === void 0 ? void 0 : _countriesStore$selec8.telegramLink;
  });
  var maxBotLink = computed(function () {
    var _countriesStore$selec9;
    return (_countriesStore$selec9 = countriesStore.selectedCountry) === null || _countriesStore$selec9 === void 0 ? void 0 : _countriesStore$selec9.maxLink;
  });
  var currencySymbol = computed(function () {
    var _profileStore$country2;
    if ((_profileStore$country2 = profileStore.country) !== null && _profileStore$country2 !== void 0 && _profileStore$country2.currency) {
      return profileStore.country.currency;
    }
    return '₽';
  });
  return {
    pdSiteName: pdSiteName,
    pdUrl: pdUrl,
    landingUrl: landingUrl,
    isCis: isCis,
    isRu: isRu,
    currentCountry: currentCountry,
    currentDomainCountry: currentDomainCountry,
    logo: logo,
    pdLogo: pdLogo,
    outgoingCallPhone: outgoingCallPhone,
    outgoingCallPhoneLink: outgoingCallPhoneLink,
    incomingCallPhone: incomingCallPhone,
    whatsappLink: whatsappLink,
    personalDataAgreementLink: personalDataAgreementLink,
    personalDataReceivingLink: personalDataReceivingLink,
    thirdPartyPersonalDataAgreementLink: thirdPartyPersonalDataAgreementLink,
    telegramBotLink: telegramBotLink,
    maxBotLink: maxBotLink,
    currencySymbol: currencySymbol
  };
});